export const ALERT_SUCCESS = "alert/success";
export const ALERT_ERROR = "alert/error";
export const ALERT_CLEAR = "alert/clear";
